import { SVGProps } from 'react'

export const ChartsSvgr = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="264"
    height="156"
    viewBox="0 0 223 135"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="4"
      y="4"
      width="218"
      height="130"
      rx="4"
      fill="#161D3A"
      stroke="black"
      stroke-width="0.5"
    />
    <rect
      x="1"
      y="1"
      width="218"
      height="130"
      rx="4"
      fill="white"
      stroke="black"
      stroke-width="0.5"
    />
    <path
      d="M77.2433 24.8438H83.7652V70.6637H77.2433V24.8438Z"
      fill="#B7C0E6"
      stroke="#293044"
      stroke-width="0.5"
    />
    <path
      d="M66.3457 49.8044H72.8676V70.6588H66.3457V49.8044Z"
      fill="#B7C0E6"
      stroke="#293044"
      stroke-width="0.5"
    />
    <path
      d="M55.453 44.2135H61.9749V70.6588H55.453V44.2135Z"
      fill="#B7C0E6"
      stroke="#293044"
      stroke-width="0.5"
    />
    <path
      d="M44.5554 56.6007H51.0773V70.6637H44.5554V56.6007Z"
      fill="#B7C0E6"
      stroke="#293044"
      stroke-width="0.5"
    />
    <path
      d="M152.208 26.0198C136.45 26.0179 122.242 35.5094 116.21 50.0682C110.179 64.6269 113.512 81.3855 124.655 92.5285C135.798 103.672 152.556 107.005 167.115 100.973C181.674 94.9415 191.165 80.7335 191.163 64.9748H152.208V26.0198Z"
      fill="#E4E7F6"
      stroke="#293044"
      stroke-width="0.5"
    />
    <path
      d="M152.208 21.0855V64.9748H196.098C196.098 40.7354 176.448 21.0855 152.208 21.0855H152.208Z"
      fill="#4A61C0"
      stroke="#293044"
      stroke-width="0.5"
    />
    <path d="M30.0808 87.799H92.6587" stroke="#293044" stroke-width="0.5" />
    <path d="M30.0808 93.7574H92.6587" stroke="#293044" stroke-width="0.5" />
    <path d="M30.0808 99.7158H92.6587" stroke="#293044" stroke-width="0.5" />
    <path d="M30.0808 105.679H63.2832" stroke="#293044" stroke-width="0.5" />
    <path d="M30.0808 70.6637H92.6587" stroke="#454953" stroke-width="0.5" />
    <path
      d="M59.8784 20.3573V19.6568C59.8784 19.3065 59.5719 19 59.2216 19C58.8714 19 58.5649 19.3065 58.5649 19.6568V20.3573C58.5649 20.7076 58.2584 21.0141 57.9081 21.0141H57.2514C56.9011 21.0141 56.5946 21.3205 56.5946 21.6708C56.5946 22.0211 56.9011 22.3276 57.2514 22.3276H57.9519C58.3022 22.3276 58.6087 22.6341 58.6087 22.9843V23.6849C58.6087 24.0351 58.9152 24.3416 59.2654 24.3416C59.6157 24.3416 59.9222 24.0351 59.9222 23.6849V22.9843C59.9222 22.6341 60.2287 22.3276 60.5789 22.3276H61.2795C61.6298 22.3276 61.9362 22.0211 61.9362 21.6708C61.9362 21.3205 61.6298 21.0141 61.2795 21.0141H60.5789C60.2287 21.0141 59.9222 20.7514 59.8784 20.3573ZM17.1454 36.2946V35.8568C17.1454 35.6378 16.9703 35.4189 16.7514 35.4189C16.5324 35.4189 16.3135 35.5941 16.3135 35.813V35.8568V36.2946C16.3135 36.5135 16.1384 36.7324 15.8757 36.7324H15.4378C15.2189 36.7324 15 36.9076 15 37.1703C15 37.3892 15.1751 37.6081 15.3941 37.6081H15.8319C16.0508 37.6081 16.2697 37.7833 16.2697 38.0022V38.44C16.2697 38.6589 16.4449 38.8779 16.6638 38.8779C16.8827 38.8779 17.1016 38.7027 17.1016 38.44V38.0022C17.1016 37.7833 17.2768 37.6081 17.4957 37.5643H17.9335C18.1524 37.5643 18.3714 37.3892 18.3714 37.1265C18.3714 36.9076 18.1962 36.6887 17.9335 36.6887H17.4957C17.3205 36.6887 17.1454 36.5135 17.1454 36.2946ZM25.6832 55.5595V55.2092C25.6832 55.0341 25.5519 54.9027 25.3768 54.9027C25.2016 54.9027 25.0703 55.0341 25.0703 55.2092V55.5595C25.0703 55.7346 24.9389 55.866 24.7638 55.866H24.3697C24.1946 55.866 24.0632 55.9973 24.0632 56.1725C24.0632 56.3476 24.1946 56.4789 24.3697 56.4789H24.72C24.8951 56.4789 25.0265 56.6103 25.0265 56.7854V57.1357C25.0265 57.3108 25.1578 57.486 25.333 57.486C25.5081 57.486 25.6832 57.3546 25.6832 57.1795V57.1357V56.7854C25.6832 56.6103 25.8146 56.4352 25.9897 56.4352H26.34C26.5151 56.4352 26.6465 56.3038 26.6465 56.1287C26.6465 55.9535 26.5151 55.7784 26.34 55.7784H26.0335C25.8584 55.9098 25.6832 55.7346 25.6832 55.5595ZM49.2389 35.5941C49.2389 35.9443 48.9325 36.2508 48.5822 36.2508C48.2319 36.2508 47.9254 35.9443 47.9254 35.5941C47.9254 35.2438 48.2319 34.9373 48.5822 34.9373C48.9762 34.9373 49.2389 35.2438 49.2389 35.5941ZM34.7903 26.6184C34.7903 27.1 34.3962 27.4941 33.9146 27.4941C33.433 27.4941 33.0389 27.1 33.0389 26.6184C33.0389 26.1368 33.433 25.7427 33.9146 25.7427C34.3962 25.7427 34.7903 26.1368 34.7903 26.6184Z"
      fill="#05CC9A"
    />
  </svg>
)
